import { CommonDataService } from 'src/app/core/services/common-data.service';
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { BookingService } from 'src/app/features/transport-operation/services/booking.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'laas-booking-detail-status-change',
  templateUrl: './booking-detail-status-change.component.html',
  styleUrls: ['./booking-detail-status-change.component.scss']
})
export class BookingDetailStatusChangeComponent extends SessionBaseComponent implements OnInit {
  @Input() booking: any;
  @Output() visibleChange: EventEmitter<any>;
  @Output() bookingDetailStatusChangeSaved: EventEmitter<any>;
  @ViewChild(Dialog) dialog!: Dialog;
  readonly preferenceKey: string;
  isVisible: boolean;
  columns: any[];
  selectedCols: any[];
  selectedRows: any[];
  isAutoChangingDoNoStatusOptions: any[];
  DOStatusOptions: any[];
  newStatusOptions: any[];
  tmpDetails: any[];
  isLoading: boolean;

  constructor(
    injector: Injector,
    private commonDataService: CommonDataService,
    private bookingService: BookingService) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.BookingDetailStatusChange;
    this.isVisible = false;
    this.booking = null;
    this.tmpDetails = [];
    this.columns = [
      { field: 'isAutoChangingDoNoStatus', header: '同步更新DO狀態' },
      { field: 'newStatus', header: '狀態更新' },
      { field: 'doNo', header: this.translateService.instant('DeliveryOrder.DoNo') }
    ];
    this.selectedCols = this.columns;
    this.selectedRows = [];
    this.isAutoChangingDoNoStatusOptions = [];
    this.DOStatusOptions = [];
    this.newStatusOptions = [];
    this.isLoading = false;
    this.visibleChange = new EventEmitter<any>();
    this.bookingDetailStatusChangeSaved = new EventEmitter<any>();
  }

  @Input() get visible(): any {
    return this.isVisible;
  }
  set visible(value: any) {
    this.isVisible = value;
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.tmpDetails = isNullOrEmpty(this.booking?.bookingDetails) ? [] : deepCopy(this.booking.bookingDetails);
    this.tmpDetails.forEach(x => x.isAutoChangingDoNoStatus = '1');
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'BookingDetailStatus')
      .subscribe({
        next: (options: any[]) => {
          this.DOStatusOptions = options.map(x => ({ label: `${x.codeKey} - ${x.codeDesc}`, value: x.codeKey }));
        }
      });
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ChooseYesOrNo')
      .subscribe({
        next: (options: any[]) => {
          this.isAutoChangingDoNoStatusOptions = options.map(x => ({ label: `${x.codeKey} - ${x.codeDesc}`, value: x.codeKey }));
        }
      });
  }

  dialogVisibleChange(event: any): void {
    this.visibleChange.emit(event);
  }

  confirmBtnClick(event: any): void {
    this.selectedRows.forEach(x => x.originalStatus = x.status);
    const updateObj = {
      bookingNo: this.booking.bookingNo,
      doNoList: this.selectedRows,
      updateUser: this.userProfile.userName
    };

    this.isLoading = true;
    this.bookingService.bookingDetailStatusChangeManually(updateObj)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: result => {
          this.dialog.close(event);
          this.bookingDetailStatusChangeSaved.emit({ originalEvent: event });
        },
        error: err => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  cancelBtnClick(event: any): void {
    this.dialog.close(event);
  }

  displayMessageArray(msgStr: string): string {
    if (isNullOrEmpty(msgStr)) {
      return '';
    }
    const array = msgStr.split(',').filter(x => isNullOrEmpty(x) === false);
    if (array.length === 0) {
      return '';
    }
    const context = array.map((x, idx) => `${idx + 1}. ${x}`).join('\n');
    return context;
  }

  getNewStatusOptions(rowData: any): any {
    return this.DOStatusOptions.filter(x => x.value !== rowData.status);
  }
}
